module.exports = ".card__title {\n  margin-bottom: 20px;\n}\n\n.margin-bottom {\n  margin-bottom: 15px;\n}\n\n.margin-top {\n  margin-top: 10px;\n}\n\nbutton.btn.btn-primary.add-btn {\n  margin-top: 20px;\n}\n\n.settings-icons i {\n  font-size: 3rem;\n  cursor: pointer;\n  margin: 10px;\n}\n\n.dropdown i {\n  font-family: FontAwesome !important;\n}\n\n.dropdown-menu{\n  left: -133px !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-settings/brokers/add-broker/add-broker.component.css
// module id = ./src/app/main-settings/brokers/add-broker/add-broker.component.css
// module chunks = main